<template>
    <div style="border-bottom: 1px solid rgb(206, 206, 206); cursor: pointer; height: 60px;" @click="openChat">
        <el-row style="display: flex; align-items: center; height: 100%;">
            <el-col :span="4" style="display: flex; align-items: center;">
                <img :src="id == 'SYSTEM' ? require('../../../../assets/img/chat/images/notice.png') : logo" height="40" width="40">
            </el-col>
            <el-col :span="16">
                <div>
                    <div class="agent-name">{{ name }}</div>
                    <div class="last-msg">{{ lastMsg }}</div>
                </div>
            </el-col>
            <el-col :span="4">
                <div style="display: flex; justify-content: flex-end; padding-right: 10px;">
                    <div class="count" v-if="count > 0">{{ count }}</div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "ChatListItem",
    props: {
        name: {
            type: String,
            required: true
        },
        lastMsg: {
            type: String,
            required: false,
            default: ""
        },
        count: {
            type: Number,
            default: 0
        },
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            logo: localStorage.getItem("chatLogo"),
        }
    },
    methods: {
        openChat() {
            this.$emit("openChat", this.id);
        }
    }
}
</script>

<style scoped>
.count {
    background-color: #ff0000;
    padding: 5px 10px;
    border-radius: 50%;
    color: #fff;
}

.agent-name {
    color: #000;
    font-size: 18px;
    padding: 5px 0;
}

.last-msg {
    color: #9c9c9c;
    font-size: 15px;
    padding: 5px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/module/chat/components/chatListItem.vue